import { derived, get, readonly, writable } from "svelte/store";
import { CLOSE_TYPES, type CloseTypes } from "./events";
import { sheetScope } from "./utils";

const log = sheetScope.scope("history");

/**
 *
 *
 */
const sheetHistory = writable<string[]>([]);
if (import.meta.env.DEV) {
  sheetHistory.subscribe((_) => log.info("sheet history change", _));
}

/**
 *
 */
export const isSheetOpen = derived(sheetHistory, (history) => history.length > 0);

/**
 *
 *
 */
const openSheetInstance = writable<HTMLOcSheetV1Element | null>(null);
/**
 *
 */
export const openSheet = readonly(openSheetInstance);
if (import.meta.env.DEV) {
  openSheet.subscribe((_) => log.info("sheet instance change", _));
}

/**
 *
 */
export const openSheetID = derived(sheetHistory, (history) => history.at(-1) ?? null);

/**
 *
 */
export const previousSheetID = derived(sheetHistory, (history) => history.at(-2) ?? null);

/**
 *
 *
 *
 */
const isSwitchingState = writable(false);
/*                                                                       */

/**
 *
 *
 */
export const noTransition = readonly(isSwitchingState);

/**
 *
 *
 *
 */
export const isSwitching = readonly(isSwitchingState);

/**
 *
 *
 */
const requestedCloseState = writable<CloseTypes | null>(null);
/*                                                     */
requestedCloseState.subscribe(() => requestedCloseState.set(null));

/**
 *
 *
 *
 */
export const requestedClose = readonly(requestedCloseState);
if (import.meta.env.DEV) {
  requestedClose.subscribe((closeType) => log.info("requestedClose changed", closeType));
}

/**
 *
 *
 */
export const lastActiveDomElement = writable<HTMLElement | null>(null);
if (import.meta.env.DEV) {
  lastActiveDomElement.subscribe((el) => log.info("lastActiveDomElement changed", el));
}

let lastHistoryLength: number = 0;
sheetHistory.subscribe((history) => {
  /*                */
  if (history.length > 0 && lastHistoryLength === 0) {
    /*                                                                                             */
    lastActiveDomElement.set(document.activeElement as HTMLElement);
  }

  /*                                                */
  /*                                                                             */
  if (history.length > 1 && lastHistoryLength === 1) {
    isSwitchingState.set(true);
  }

  lastHistoryLength = history.length;
});

/**
 *
 *
 *
 *
 *
 *
 *
 */
export function next(sheetId: string): void {
  /*                                                                */
  if (sheetId === get(openSheetID)) return;

  sheetHistory.update((history) => [...history, sheetId]);
}

/**
 *
 *
 *
 *
 *
 */
export function back(): void {
  sheetHistory.update((history) => {
    history.pop();

    /*                                                                          */
    /*                                                                       */
    if (history.length === 0) {
      requestedCloseState.set(CLOSE_TYPES.CLOSED_PROGRAMMATICALLY);
    }

    return history;
  });
}

/**
 *
 *
 */
export function close(reason: CloseTypes = CLOSE_TYPES.CLOSED_PROGRAMMATICALLY): void {
  requestedCloseState.set(reason);
  sheetHistory.set([]);
}

function handleESCKey(e: KeyboardEvent): void {
  if (e.code === "Escape") {
    close(CLOSE_TYPES.CLOSED_WITH_ESCAPE);
  }
}

/*                                                              */
isSheetOpen.subscribe((isOpen) => {
  if (isOpen) {
    /*                                                                             */
    document.addEventListener("keydown", handleESCKey);
  } else {
    /*                                                                                      */
    document.removeEventListener("keydown", handleESCKey);

    /*                                         */
    lastActiveDomElement.set(null);
    isSwitchingState.set(false);
    openSheetInstance.set(null);
  }
});

/**
 *
 *
 *
 *
 *
 *
 *
 *
 */
/*                                                                        */
export function useSheetHistory(host: HTMLOcSheetV1Element) {
  /*                                                                            */
  const isActiveSheet = derived(openSheetID, (sheetId) => sheetId === host.id);

  /*                                                                                      */
  /*                                                              */
  isActiveSheet.subscribe((isActive) => {
    if (import.meta.env.DEV) {
      log.info("useSheetHistory.isActiveSheet", host.id, isActive);
    }

    if (isActive) openSheetInstance.set(host);
  });

  /**
 *
 *
 */
  let currentOpenState: boolean | undefined = false;

  return {
    /**
 *
 *
 */
    isActiveSheet,

    /**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
    syncInstanceOpenState(isOpen: boolean | undefined, openSheetId: string | null) {
      if (import.meta.env.DEV) {
        log.debug("syncInstanceOpenState", host.id, "is open", isOpen, "openSheettId", openSheetId);
      }

      /*                                                                         */
      /*                                                  */
      if (isOpen === currentOpenState) {
        currentOpenState = openSheetId === host.id;
        return currentOpenState;
      }

      /*                                                            */
      /*                                                                                     */
      /*                                               */
      if (isOpen) {
        if (import.meta.env.DEV) {
          log.scope("syncInstanceOpenState").info("Open sheet as requested by prop", host.id);
        }

        next(host.id);
      } else if (openSheetId === host.id) {
        if (import.meta.env.DEV) {
          log.scope("syncInstanceOpenState").info("close sheet as requested by prop", host.id);
        }

        close(CLOSE_TYPES.CLOSED_PROGRAMMATICALLY);
      }

      currentOpenState = isOpen;
      return currentOpenState;
    },
  };
}
